import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../store/configureStore";
import CountriesService from "Services/countries";
import { ICountry } from "../types/countries";

interface ICountriesState {
  loading: boolean;
  data: ICountry[];
  error: boolean;
}

const initialState: ICountriesState = {
  loading: false,
  data: [],
  error: false,
};

const countriesSlice = createSlice({
  name: "countries",
  initialState,
  reducers: {
    setLoader: (state) => {
      state.loading = true;
      state.error = initialState.error;
    },
    setData: (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.data = payload;
    },
    setError: (state) => {
      state.loading = false;
      state.error = true;
    },
  },
});

const { setLoader, setData, setError } = countriesSlice.actions;

export const getCountries = (): AppThunk => async (dispatch) => {
  dispatch(setLoader());
  try {
    const response = await CountriesService.get();
    dispatch(setData(response));
  } catch (error) {
    dispatch(setError());
  }
};

export default countriesSlice.reducer;
